import { Link } from 'react-router-dom';
import { footerLinks, footerContact } from '@/mocks/navigation';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-5 whitespace-nowrap">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-gamepad-line text-lg text-background-50"></i>
              </div>
              <span className="text-xl font-bold font-heading text-background-50">
                九游娱乐
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed mb-6 max-w-sm">
              九游娱乐是领先的在线娱乐平台，致力于为玩家提供安全、公平、优质的游戏体验。海量精品游戏，丰厚会员福利，7×24小时贴心服务。
            </p>
            <div className="flex flex-wrap gap-3">
              <a href="tel:4008889999" className="flex items-center gap-2 px-4 py-2 rounded-lg bg-background-50/10 hover:bg-background-50/20 transition-colors text-sm text-background-200 whitespace-nowrap">
                <i className="ri-phone-line text-accent-500"></i>
                {footerContact.phone}
              </a>
              <a href="mailto:service@jiuyouyule.com" className="flex items-center gap-2 px-4 py-2 rounded-lg bg-background-50/10 hover:bg-background-50/20 transition-colors text-sm text-background-200 whitespace-nowrap">
                <i className="ri-mail-line text-accent-500"></i>
                {footerContact.email}
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">{footerLinks.games.title}</h4>
            <ul className="flex flex-col gap-2.5">
              {footerLinks.games.links.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-sm text-background-400 hover:text-accent-500 transition-colors duration-200 whitespace-nowrap">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">{footerLinks.service.title}</h4>
            <ul className="flex flex-col gap-2.5">
              {footerLinks.service.links.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-sm text-background-400 hover:text-accent-500 transition-colors duration-200 whitespace-nowrap">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">{footerLinks.about.title}</h4>
            <ul className="flex flex-col gap-2.5">
              {footerLinks.about.links.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-sm text-background-400 hover:text-accent-500 transition-colors duration-200 whitespace-nowrap">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-background-50/10 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 九游娱乐 版权所有 | 经营许可证编号：B2-20260001
          </p>
          <div className="flex items-center gap-6">
            <Link to="/article/terms" className="text-xs text-background-500 hover:text-accent-500 transition-colors duration-200 whitespace-nowrap">用户协议</Link>
            <Link to="/article/privacy" className="text-xs text-background-500 hover:text-accent-500 transition-colors duration-200 whitespace-nowrap">隐私政策</Link>
            <Link to="/about#contact" className="text-xs text-background-500 hover:text-accent-500 transition-colors duration-200 whitespace-nowrap">联系我们</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}